"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ShieldCheck, PhoneCall } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CapeCoralPestControlHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="cape-coral-pest-control-hero" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div ref={textRef} className={`lg:col-span-7 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-4 border-2 border-foreground font-bold uppercase tracking-wider text-sm bg-card text-card-foreground">
              <ShieldCheck className="size-4" />
              <span>Trusted Local Experts</span>
            </div>

            <div className="mb-8 text-sm font-bold uppercase tracking-widest opacity-80">
              We are licensed, insured, and locally owned.
            </div>
            
            <h1 className="font-default text-5xl md:text-7xl lg:text-[86px] leading-[1.05] tracking-tight uppercase">
              Professional Pest Control in Cape Coral, FL
            </h1>
            
            <p className="mt-8 text-lg md:text-xl font-medium max-w-3xl opacity-90 leading-relaxed">
              Cape Coral's unique landscape, defined by over 400 miles of navigable canals and high humidity, creates a specialized ecosystem where pests thrive year-round. Waterfront homes are particularly susceptible to intense pest pressure requiring professional <Link to="/TermiteTreatmentPage" className="underline decoration-primary hover:text-primary transition-colors">termite treatment</Link> and <Link to="/MosquitoControlPage" className="underline decoration-primary hover:text-primary transition-colors">mosquito control</Link>. Our comprehensive <Link to="/PestControlPage" className="underline decoration-primary hover:text-primary transition-colors">pest control services</Link> also protect residents in <Link to="/PortCharlottePestControlPage" className="underline decoration-primary hover:text-primary transition-colors">Port Charlotte</Link> and <Link to="/NorthFortMyersPestControlPage" className="underline decoration-primary hover:text-primary transition-colors">North Fort Myers</Link>, ensuring the warm Southwest Florida climate doesn't compromise your home's safety.
            </p>

            <div className="mt-6 p-4 border-l-4 border-foreground bg-card/50 font-bold text-lg">Same-day service available • Monthly plans starting from $35 • Free re-treatments if pests return.</div>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button size="lg" asChild className="text-lg px-8 h-14 rounded-none shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all">
                <Link to="/ContactPage">
                  <PhoneCall className="mr-2 size-5" />
                  Get a Free Quote
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="text-lg px-8 h-14 rounded-none border-2 border-foreground text-foreground hover:bg-foreground hover:text-background bg-transparent shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all">
                <Link to="/PestControlPage">Explore Services</Link>
              </Button>
            </div>
          </div>

          <div ref={imgRef} className={`lg:col-span-5 relative hidden lg:block transition-all duration-1000 delay-300 ease-out ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            
          </div>
        </div>
      </div>
    </section>;
}